import "react/jsx-runtime";
import { isOutputState } from "./types.js";
function getMergedStoreLocatorInfo(allParts) {
  const storeLocatorParts = [];
  allParts.forEach((p, i) => {
    if (p.type !== "tool-show_store_locator") return;
    const slPart = p;
    if (!isOutputState(slPart.state)) return;
    const output = slPart.output;
    if (!output || output.error || output.isOnlineOnly || !output.hasStores) return;
    const skus = output.stacklineSkus ?? [];
    if (skus.length > 0) {
      storeLocatorParts.push({ index: i, skus });
    }
  });
  if (storeLocatorParts.length <= 1) return null;
  const allSkus = [...new Set(storeLocatorParts.flatMap((p) => p.skus))];
  return { renderIndex: storeLocatorParts[storeLocatorParts.length - 1].index, allSkus };
}
export {
  getMergedStoreLocatorInfo
};
//# sourceMappingURL=StoreLocatorPart.js.map
